import styles from "./CreateUpdateStreetLightView.module.scss";

import Button from "../../../../../../common/components/atom/Button/Button";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import PoleSelectorPresenter from "../../../Pole/PoleSelector/PoleSelector";
import { CreateUpdateStreetLightViewProps } from "../../../../streetLight/withCreateUpdateForm";

type CreateUpdateStreetLightViewImp = CreateUpdateStreetLightViewProps;

export default function CreateUpdateStreetLightView({
  isUpdate,
  formData,
  setFormData,
  errorFormStatus,
  onHandleSubmit,
  errorMessage,
  isLoading,
  labelSubmitButton,
  planId,
}: CreateUpdateStreetLightViewImp) {
  const variant = "dark";

  return (
    <div
      className={[
        styles["container-form"],
        styles["container-form--" + variant],
      ].join(" ")}
    >
      <p color="white">{errorMessage}</p>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <TextInput
          variant={variant}
          label="Nom"
          value={formData?.name}
          rows={10}
          onChange={(e) => {
            setFormData && setFormData({ ...formData, name: e.target.value });
          }}
          error={errorFormStatus?.isErrorName}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <TextInput
          variant={variant}
          label="Numéro"
          value={formData?.number}
          onChange={(e) => {
            setFormData && setFormData({ ...formData, number: e.target.value });
          }}
          error={errorFormStatus?.isErrorNumber}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <TextInput
          variant={variant}
          label="Noeud Zhaga Devui"
          value={formData?.zhagaDevui}
          onChange={(e) => {
            setFormData && setFormData({ ...formData, zhagaDevui: e.target.value });
          }}
          error={errorFormStatus?.isErrorZhagaDevui}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <PoleSelectorPresenter
          isError={errorFormStatus?.isErrorPole}
          onChange={(pole) => {
            setFormData && setFormData({ ...formData, pole: pole });
          }}
          value={formData?.pole}
          planId={planId}
          variant={variant}
          
        />
      </div>

      <div className={styles["container-form__section"]}>
        <Button
          label={labelSubmitButton}
          variant={"dark-parimary"}
          isLoading={isLoading}
          onClick={onHandleSubmit}
        />
      </div>
    </div>
  );
}
